export type ViolationsType = Record<ViolationLevel, { [id: string]: ViolationType }>

export type ViolationLevel = 'error' | 'warning'

export enum ViolationSource {
    Plugin = 'plugin',
}

export type ViolationType = {
    message: string
    type: ViolationLevel
    id: string
    source?: ViolationSource
    onClick?: (violation: ViolationType) => void
}
